import { useNavigate, useOutletContext } from 'react-router-dom'

import { Home } from './Home'

export const HomeContainer = () => {
  const navigate = useNavigate()
  const { setActiveTab } = useOutletContext<{ setActiveTab: (tab: string) => void }>()

  const handleOnClick = (rota: string) => {
    setActiveTab(rota.replace('/', ''))
    navigate(rota)
  }

  return <Home handleOnClick={handleOnClick} />
}
